import createAxiosInstance from './createAxiosInstance'

const corePath = process.env.VUE_APP_CORE_URL
const coreInstance = createAxiosInstance(corePath)

export const apiCore = {
  getCommunityMainService: () => coreInstance.get('/api/Community/CommunityMainService'), // 取得各種功能、功能卡片之開關
  useSnOpenAccount: (data, config) => coreInstance.post('/api/AuthorizationSn/UseSnOpenAccount', data, {
    metadata: {
      userHandlesErrors: true, // 400 時不由攔截器處理錯誤 Alert
      isApiNoNeedToLoginCommunity: true // 登入進特定社區前即可進行社區開通
    },
    ...config
  }) // 使用開通序號開通社區
}
